import BackgroundImg from '../../assets/portfolio/covetrus/hero-covetrus.webp';

export const CovetrusBanner = {
  title: 'Covetrus Animal Health',
  description: 'In-clinic checkout & prescription management',
  background: BackgroundImg,
}